// extracted by mini-css-extract-plugin
export default {"content-wrapper":"select-floor_content-wrapper__ZpRM7","content":"select-floor_content__2zz13"};